"use strict";
/* eslint-disable no-dupe-keys */
module.exports = {
    complaint: 'Reklamation' || 'complaint',
    writeComplaint: 'Skapa reklamation' || 'writeComplaint',
    beginReview: 'Granska' || 'beginReview',
    comment: 'Kommentera' || 'comment',
    resolveComplaint: 'Klarmarkera' || 'resolveComplaint',
    cancel: 'Makulera' || 'cancel',
    ensureInvariants: 'Räkna om totaler' || 'ensureInvariants',
    upsert: '' || 'upsert',
    upsertWhenEmpty: '' || 'upsertWhenEmpty',
    updateWhenEmpty: '' || 'updateWhenEmpty',
    update: '' || 'update',
    id: 'Identitet' || 'id',
    complaintNumber: 'Reklamationsnummer' || 'complaintNumber',
    complaintDate: 'Reklamationsdatum' || 'complaintDate',
    resolution: 'Lösning' || 'resolution',
    order: 'Order' || 'order',
    cancelled: 'Makulerad' || 'cancelled',
    contactName: 'Kontaktperson' || 'contactName',
    contactPhone: 'Telefonnummer' || 'contactPhone',
    contactEmail: 'E-post' || 'contactEmail',
    complaintType: 'Ärendetyp' || 'complaintType',
    complaintTypes: {
        customerGotWrongOrder: 'Fel order levererades' || 'customerGotWrongOrder',
        wrongArticles: 'Fel artiklar levererades' || 'wrongArticles',
        wrongPrices: 'Fel pris' || 'wrongPrices',
        missingArticles: 'Saknas artiklar på order' || 'missingArticles',
        articlesBrokenInTransport: 'Artiklar gick sönder i leverans' || 'articlesBrokenInTransport',
        articleDoesNotMeetQualityExpectations: 'Artikeln tillfredställer inte kvalitetskrav' ||
            'articleDoesNotMeetQualityExpectations',
        lostInDelivery: 'Leveransen är försvunnen' || 'lostInDelivery',
        cancelledDueToLateHandling: 'Ordern blev så sen så att den inte längre är aktuell' ||
            'cancelledDueToLateHandling',
        other: 'Annat' || 'other',
    },
    resolutionType: 'Åtgärdstyp' || 'resolutionType',
    resolutionTypes: {
        credit: 'Krediterad - vi får inte tillbaka artiklarna' || 'credit',
        return: 'Krediterad - retur bokad' || 'return',
        customerPayed: 'Kunden köper extra produkterna' || 'customerPayed',
        other: 'Annat - manuell hantering av ekonomi' || 'other',
        none: 'Ingen åtgärd' || 'none',
    },
    description: 'Beskrivning' || 'description',
    assignedResponsibility: 'Ersättningsansvarig' || 'assignedResponsibility',
    assignedResponsibilities: {
        warehouse: 'Vinden - faktura sker direkt' || 'warehouse',
        supplier: 'Leverantör - ersättning hanteras i avräkning' || 'supplier',
        flaivy: 'Flaivy' || 'flaivy',
        none: 'Ingen' || 'none',
    },
    resolutionDate: 'Avslutad' || 'resolutionDate',
    complaintState: 'Status' || 'complaintState',
    complaintStates: {
        received: 'Mottagen' || 'received',
        inReview: 'Granskas' || 'inReview',
        resolved: 'Klar' || 'resolved',
    },
    customerAdjustmentInvoice: 'Kreditfaktura mot kund' || 'customerAdjustmentInvoice',
    freightClaimsInvoice: 'Faktura mot vinden för ersättning' || 'freightClaimsInvoice',
    complaintRows: {
        id: 'Identitet' || 'id',
        article: 'Artikel' || 'article',
        quantity: 'Antal i styck' || 'quantity',
        discount: 'Procentrabatt' || 'discount',
        expectedPrice: 'Förväntat pris per styck' || 'expectedPrice',
    },
    complaintImages: {
        id: 'Identitet' || 'id',
        image: 'Bild' || 'image',
    },
};
